{
  "feeCalculator": {
    "sections": {
      "inputs": "Eingaben",
      "calculations": "Berechnungen"
    },
    "tabs": {
      "tenantAndTransient": "Mieter- & Durchfluggebühren",
      "annualFees": "Jahresgebühren"
    },
    "rateLabels": {
      "default": "Standard"
    },
    "inputs": {
      "aircraft": {
        "title": "Flugzeug",
        "subtitle": "Luftfahrzeug, für das du Gebühren berechnen möchtest. Wir verwenden Spannweite und Länge, um die Fläche für die Berechnung zu ermitteln.",
        "makeModel": "Typ/Modell",
        "dimensions": "Abmessungen"
      },
      "buffer": {
        "title": "Puffer",
        "subtitle": "Ein Puffer wird an jeder Seite der Abmessungen hinzugefügt. Beispiel: Ein 2{{unit}}-Puffer fügt insgesamt 4{{unit}} zur Länge und 4{{unit}} zur Spannweite hinzu."
      },
      "baseTenantRate": {
        "title": "Basis-Mietpreis",
        "subtitle": "Satz für die Berechnung der monatlichen Mieterpreise.",
        "label": "$ / {{unit}}² / Monat"
      },
      "transientRate": {
        "title": "Durchgangsrate",
        "subtitle": "Satz für die Berechnung der nächtlichen Transient-Preise.",
        "label": "$ / {{unit}}² / Tag"
      },
      "presets": {
        "title": "Vorlagen",
        "subtitle": "Standardpreise unter Einstellungen > Kalkulation hinzufügen/bearbeiten.",
        "label": "Tarife"
      },
      "camFees": {
        "title": "Nebenkosten für Gemeinschaftsflächen",
        "subtitle": "Nebenkosten werden zur monatlichen Mieterrate hinzugefügt. Du kannst eine prozentuale Gebühr oder eine {{unit}}²-Gebühr angeben.",
        "or": "o."
      }
    },
    "calculations": {
      "aircraftSquare": "Flugzeug-Stellplatz {{unit}}",
      "aircraftSquareSubtitle": "Platzbedarf des Flugzeugs. Gemessen als Spannweite x Länge.",
      "totalSquare": "Gesamtfläche {{unit}}",
      "totalSquareSubtitle": "Vom Flugzeug beanspruchte Fläche + Puffer (falls angegeben).",
      "aircraftFee": "Flugzeuggebühr",
      "camFees": "CAM-Gebühren",
      "totalFee": "Gesamtgebühr",
      "tenantMonthly": "Mieter (monatlich)",
      "transientDaily": "Durchreisend (täglich)"
    }
  }
}
